<template>
  <div class='h-dialogContainer'>
    <div class='row h-row-inputBox'>
      <form :id='caculateFormId'>
        <div v-if='hackReset' v-for="dataItem in getFormParam">
          <Son_Text :ref='dataItem.name' v-if="dataItem.type === 'text'" :data='dataItem' :opCode='parseOpCode' :parseListIndexOf='parseListIndexOf'></Son_Text>
          <Son_Password :ref='dataItem.name' v-if="dataItem.type === 'password'" :data='dataItem' :opCode='parseOpCode' :parseListIndexOf='parseListIndexOf'></Son_Password>
          <Son_Select :ref='dataItem.name' v-if="dataItem.type === 'select'" :data='dataItem' :opCode='parseOpCode' :parseListIndexOf='parseListIndexOf'></Son_Select>
          <Son_CheckBox :ref='dataItem.name' v-if="dataItem.type === 'checkbox'" :data='dataItem' :opCode='parseOpCode' :parseListIndexOf='parseListIndexOf'></Son_CheckBox>
          <!--<Son_CheckArray :ref='dataItem.name' v-if="dataItem.type === 'checkArray'" :data='dataItem' :opCode='parseOpCode'></Son_CheckArray>-->
          <Son_Radio :ref='dataItem.name' v-if="dataItem.type === 'radio'" :data='dataItem' :opCode='parseOpCode' :parseListIndexOf='parseListIndexOf'></Son_Radio>
          <Son_Date :ref='dataItem.name' v-if="dataItem.type === 'date'" :data='dataItem' :opCode='parseOpCode' :parseListIndexOf='parseListIndexOf'></Son_Date>
        </div>
      </form>
    </div>
    <div class="row">
      <span>&nbsp;</span>
    </div>
    <!--<button @click="validateResult()">Get Validate</button>-->
    <!--<button @click="getDatas">GET DATAS</button>-->
    <!--<button @click="getRefObj">GET REFS</button>-->
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import bus from './tools/bus';
import Son_Text from './component/Son_Text';
import Son_Password from './component/Son_Password';
import Son_Select from './component/Son_Select';
import Son_CheckBox from './component/Son_CheckBox';
import Son_CheckArray from './component/Son_CheckArray';
import Son_Radio from './component/Son_Radio';
import Son_Date from './component/Son_Date';

// _addFlag -1:批量添加 0:添加 1:修改 2:批量修改
export default {
  name: 'ParseForm',
  props: [
    'formParams',
    'opCode',
    'funcClick',
    'funcBlur',
    'funcKeyUp',
    'funcOnChange',
    'emit',
    'formId',
    'parseListIndexOf'
  ],
  components: {
    Son_Text,
    Son_Password,
    Son_Select,
    Son_CheckBox,
    Son_CheckArray,
    Son_Radio,
    Son_Date
  },
  data() {
    return {
      hackReset: true,
      validateObj: '',
      refObj: {} ,
      options: {
        // customPlacement: function(inputElement, errorElement) {
        //   inputElement = inputElement.closest('.form-group').querySelector('.error');
        //   inputElement.parentElement.appendChild(errorElement);
        // },
        rules: {
        },
        validationComplete: function (args) {
          if (args.status === 'success') {
            //
          } else {
            //
          }
        },
      },
    };
  },
  computed: {
    getFormParam() {
      return this.formParams;
    },
    parseOpCode() {
      switch (this.opCode) {
        case 'batchAdd':
          this.opCode = '3';
          break;
        case 'add':
          this.opCode = '0';
          break;
        case 'mod':
          this.opCode = '1';
          break;
        case 'batchMod':
          this.opCode = '2';
          break;
        default:
      }
      return this.opCode;
    },

    caculateFormId() {
      console.log('--------', this.formId, this.opCode);
      if (this.parseListIndexOf !== undefined) {
        return this.formId + '_' + this.opCode + '_list_' + this.parseListIndexOf;
      }
      return this.formId + '_' + this.opCode;
    }
  },
  methods: {
    setData(_name, _value) {
      if (this.$refs === {}) { console.log('请不要在页面初始化时执行该方法!该方法只适用于渲染完成后setData.'); return; }
      if (this.$refs[_name] !== undefined && this.$refs[_name][0] !== undefined) {
        this.$refs[_name][0].setData(_value);
        try {
          this.validateResult([_name]);
        } catch (e) {
          ;
        }
      }
    },

    getDatas() {
      const _datas = new Map();
      this.$children.forEach((item) => {
        _datas.set(item.getData().name, item.getData().paramVal);
      });
      return _datas;
    },

    setDatas(_datas) {
      if (_datas instanceof Map) {
        try {
          const $this = this;
          for (let [_key, _value] of _datas) {
            $this.setData(_key, _value);
          }
        } catch (e) {
          console.log('subscriberTools set Datas error');
        }
      } else {
        try {
          const $this = this;
          for (let _key in _datas) {
            $this.setData(_key, _datas[_key]);
          }
        } catch (e) {
          console.log('subscriberTools set Datas error');
        }
      }
    },

    /**
     * 设置readonly背景颜色依然为"白"
     */
    setReadonlyNoGray(_name) {
      if (this.$refs === {}) { console.log('请不要在页面初始化时执行该方法!'); return; }
      if (this.$refs[_name] !== undefined && this.$refs[_name][0] !== undefined) {
        this.$refs[_name][0].setReadOnlyBackgroundNoGray();
      }
    },

    /**
     * 移除readonly背景颜色依然为"白"
     */
    removeReadonlyNoGray(_name) {
      if (this.$refs === {}) { console.log('请不要在页面初始化时执行该方法!'); return; }
      if (this.$refs[_name] !== undefined && this.$refs[_name][0] !== undefined) {
        this.$refs[_name][0].removeReadOnlyBackgroundNoGray();
      }
    },

    templetCover(attr) {
      const _datas = this.getDatas();
      try {
        for (let i = 0; i < this.formParams.length; i++) {
          attr.forEach((attrItem) => {
            if (this.formParams[i].name === attrItem.name) {
              this.formParams[i] = attrItem;
            }
          });
          if (_datas.get(this.formParams[i].name) !== undefined) {
            this.formParams[i].value = _datas.get(this.formParams[i].name);
          }
        }
      } catch (e) {
        ;
      }
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    },

    /**
     * 表单验证方法
     * @param _needValidate 数组(传验证的name),不传全部验证，传则只验证数组内的
     * @param func
     */
    validateResult(_needValidate = []) {
      const $this = this;
      let validateRes = true;
      if (_needValidate.length === 0) {
        try {
          $this.formParams.forEach((_item) => {
            try {
              if (_item.hidden !== true && _item.readonly !== true && _item.disabled !== true && $this.validateObj.rules[_item.name] !== undefined && $this.validateObj.validate(_item.name) === false) {
                validateRes = false;
                return false;
              }
            } catch (e) {
              console.log('subscriber validate error, name:', _item.name, e);
            }
            return true;
          });
        } catch (e) {
          ;
        }
      } else {
        _needValidate.forEach((_item) => {
          setTimeout(() => {
            if ($this.validateObj.validate(_item) === false) {
              validateRes = false;
              return false;
            }
          }, 0);
          return true;
        });
      }
      return validateRes;
    },

    /**
     * 返回内部属性ref
     */
    getRefObj(name) {
      return this.refObj[name];
    },

    /**
     * 绑定内部属性ref
     */
    $bindRefToUpdate() {
      for (let key in this.$refs) {
        try {
          this.refObj[key] = this.$refs[key][0].getRefObj();
        } catch (e) {
          ;
        }
      };
    },

    /**
     * 绑定单击事件
     */
    bindClickFunc() {
      if (this.funcClick !== undefined) {
        try {
          for (let [_key, _value] of this.funcClick) {
            if (_value === undefined) continue;
            if (typeof _value === 'function') {
              this.$refs[_key][0].clickFunc = () => {
                if (this.$refs[_key][0].data.disabled !== true) {
                  try {
                    if (this.parseListIndexOf !== undefined) {
                      bus.$emit('$clickBus', this.parseListIndexOf);
                    }
                  } catch (e) {
                    console.log('subscriber bind ParseList emit IndexOf-Event error', e);
                  }
                  _value();
                }
              };
            } else {
              this.$refs[_key][0].checkBoxClickFunc = _value;
            }
          }
        } catch (e) {
          ;
        }
      }
    },

    /**
     * 绑定Blur事件
     */
    bindBlurFunc() {
      if (this.funcBlur !== undefined) {
        try {
          for (let [_key, _value] of this.funcBlur) {
            if (_value === undefined) continue;
            if (typeof _value === 'function') {
              this.$refs[_key][0].blurFunc = () => { _value(); }
            }
          }
        } catch (e) {
          ;
        }
      }
    },

    /**
     * 绑定Key Up事件
     */
    bindKeyUpFunc() {
      if (this.funcKeyUp !== undefined) {
        try {
          for (let [_key, _value] of this.funcKeyUp) {
            if (_value === undefined) continue;
            if (typeof _value === 'function') {
              this.$refs[_key][0].keyUpFunc = () => { _value(); }
            }
          }
        } catch (e) {
          ;
        }
      }
    },

    /**
     * 绑定onChange事件
     */
    bindChangeFunc() {
      if (this.funcOnChange !== undefined) {
        try {
          for (let [_key, _value] of this.funcOnChange) {
            if (_value === undefined) continue;
            if (typeof _value === 'function') {
              this.$refs[_key][0].changeFunc = () => { _value(); }
            }
          }
        } catch (e) {
          ;
        }
      }
    },

    $childSelectChange(attr) {
      if (attr === undefined) return;
      if (this.emit !== undefined)
        this.emit(attr);
    },

    /**
     *
     * @param _name 字段名称
     * @param _type 属性名称 (例如json里的 readonly, hidden 等)
     * @param _value 对应的值
     */
    setAttrByName(_name, _type, _value) {
      if (this.$refs[_name] !== undefined && this.$refs[_name][0] !== undefined) {
        this.$refs[_name][0].setParam(_type, _value);
      }
    },
    /**
     *
     * @param _name 字段名称
     * @param _type
     */
    getAttrByName(_name, _type) {
      if (this.$refs[_name] !== undefined && this.$refs[_name][0] !== undefined) {
        return this.$refs[_name][0].getParam(_type);
      }
    },


    // 设置表单验证
    setValidate(_name, _validate) {
      if (_validate !== undefined)
      this.validateObj.addRules(_name, _validate);
    },

    // 移除表单验证
    removeValidate(_name) {
      this.validateObj.removeRules(_name);
    },

    /**
     * 初始化验证方法
     */
    $initValidate() {
      const $this = this;
      if (this.parseListIndexOf === undefined) {
        this.validateObj = new FormValidator('#' + this.formId + '_' + this.opCode, this.options);
      } else {
        this.validateObj = new FormValidator('#' + this.formId + '_' + this.opCode + '_list_' + this.parseListIndexOf, this.options);
      }
      try {
        $this.formParams.forEach((_item) => {
          if (_item.type === 'text' || _item.type === 'password') {
            if (_item.readonly !== true) {
              this.setValidate(_item.name, _item.validate);
            }
          };
        });
      } catch (e) {
        ;
      }
    },

    $initFunc() {
      this.bindClickFunc();
      this.bindBlurFunc();
      this.bindKeyUpFunc();
      this.bindChangeFunc();
    }

  },
  updated() {
    this.$initFunc();
    this.$initValidate();
    this.$bindRefToUpdate();
  },
  mounted() {
  }
};
</script>

<style scoped>

</style>
